import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  TreeSelectionsReducer,
} from './common.js';

const PlacementOrderingSelectionsReducer = TreeSelectionsReducer;

const PlacementOrderingSelectionsAggregator = ({ responses, question }) =>
  (responses || []).reduce((acc, response) => {
    const { choices } = question || {};
    const { data } = response || {};
    const { value } = data || [];

    if (!value) return acc;

    (value || []).forEach((choiceId, index) => {
      if (!acc[index]) {
        acc[index] = {};
      }

      if (!acc[index][choiceId]) {
        const selectedChoice = (choices || []).find(
          choice => choice.id === choiceId
        );

        acc[index][choiceId] = {
          count: 0,
          value: selectedChoice && selectedChoice.label,
        };
      }

      acc[index][choiceId].count += 1;
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(PlacementOrderingSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(PlacementOrderingSelectionsReducer),
};
